import React, { useState } from "react";

const DoNotSell = () => {
  const [email, setEmail] = useState("");
  const [requestType, setRequestType] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !requestType) {
      setError("Please enter your email and select a request type.");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      const res = await fetch(`https://api.home-helper.com/api/privacy/request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email,
          requestType
        })
      });

      // Always treat as success to avoid enumeration
      if (res.ok) {
        setSubmitted(true);
      } else {
        setSubmitted(true);
      }
    } catch (err) {
      console.error("Privacy request submit failed:", err);
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div style={styles.container}>
        <h2 style={styles.heading}>Request Received</h2>
        <p style={styles.text}>
          Thank you. If the email address you provided is valid, you will
          receive a message shortly asking you to confirm your request.
        </p>
        <p style={styles.text}>
          Once confirmed, we will process your request in accordance with
          applicable privacy laws.
        </p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Privacy Request</h2>

      <p style={styles.text}>
        You may use this form to exercise your privacy rights. Enter your email
        address and select the type of request you would like to make.
      </p>

      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>
          Email address
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={styles.input}
            placeholder="you@example.com"
            disabled={submitting}
          />
        </label>

        <label style={styles.label}>
          Request type
          <select
            value={requestType}
            onChange={(e) => setRequestType(e.target.value)}
            required
            style={styles.select}
            disabled={submitting}
          >
            <option value="">Select a request</option>
            <option value="DO_NOT_SELL">
              Do not sell my personal information
            </option>
            <option value="DATA_DISCLOSURE">
              Get a disclosure of my personal data
            </option>
            <option value="DATA_COPY">
              Get a copy of my personal data
            </option>
            <option value="DATA_CORRECTION">
              Correct or update my personal data
            </option>
          </select>
        </label>

        {error && <p style={styles.error}>{error}</p>}

        <button
          type="submit"
          disabled={submitting}
          style={{
            ...styles.button,
            opacity: submitting ? 0.6 : 1
          }}
        >
          {submitting ? "Submitting…" : "Submit Request"}
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "520px",
    margin: "0 auto",
    padding: "32px",
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
  },
  heading: {
    marginBottom: "12px"
  },
  text: {
    marginBottom: "16px",
    color: "#444"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontWeight: 500
  },
  input: {
    marginTop: "6px",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  },
  select: {
    marginTop: "6px",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "6px",
    border: "1px solid #ccc"
  },
  button: {
    marginTop: "12px",
    padding: "12px",
    fontSize: "16px",
    fontWeight: 600,
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    backgroundColor: "#2563eb",
    color: "#ffffff"
  },
  error: {
    color: "#b91c1c",
    fontSize: "14px"
  }
};

export default DoNotSell;
